import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

import { AppUpdateService } from './services/app-update.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  showFooter = true;

  hideFooterOn: string[] = ['/shop', '/pesanan', '/delivery'];

  constructor(
    private router: Router,
    private titleService: Title,
    public updateService: AppUpdateService
  ) {
    if (environment.appTitle) {
      this.titleService.setTitle(environment.appTitle);
    }

    this.router.events
      .pipe(filter((e) => e instanceof NavigationEnd))
      .subscribe((e: any) => {
        const url = e.urlAfterRedirects || e.url;
        this.showFooter = !this.hideFooterOn.includes(url);
      });
  }

  ngOnInit(): void {
    this.updateManifestAndMeta();
  }

  private updateManifestAndMeta(): void {
    const appType = (environment as any).appType || 'sales';
    const appTitle = (environment as any).appTitle || 'Warung Pangan';

    const manifestLink = document.getElementById('app-manifest') as HTMLLinkElement;
    const manifestUrl = `manifest.${appType}.json`;

    if (manifestLink) {
      manifestLink.setAttribute('href', manifestUrl);
    } else {
      const link = document.createElement('link');
      link.id = 'app-manifest';
      link.rel = 'manifest';
      link.href = manifestUrl;
      document.head.appendChild(link);
    }

    const appleTitleMeta = document.querySelector('meta[name="apple-mobile-web-app-title"]');
    if (appleTitleMeta) {
      appleTitleMeta.setAttribute('content', appTitle);
    }

    let appNameMeta = document.querySelector('meta[name="application-name"]');
    if (!appNameMeta) {
      appNameMeta = document.createElement('meta');
      appNameMeta.setAttribute('name', 'application-name');
      document.head.appendChild(appNameMeta);
    }
    appNameMeta.setAttribute('content', appTitle);
  }
}
